import {
  //
  ADD_SLICK_CARE_PROFILES,
  ADD_SLICK_CARE_PROFILES_FAILURE,
  ADD_SLICK_CARE_PROFILES_SUCCESS,
  //
  DELETE_SLICK_CARE_PROFILES,
  DELETE_SLICK_CARE_PROFILES_FAILURE,
  DELETE_SLICK_CARE_PROFILES_SUCCESS,
  //
  EDIT_SLICK_CARE_PROFILES,
  EDIT_SLICK_CARE_PROFILES_FAILURE,
  EDIT_SLICK_CARE_PROFILES_SUCCESS,
  //
  FETCH_SLICK_CARE_PROFILES,
  FETCH_SLICK_CARE_PROFILES_FAILURE,
  FETCH_SLICK_CARE_PROFILES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SEARCH_SLICK_CARE_PROFILES,
  SEARCH_SLICK_CARE_PROFILES_FAILURE,
  SEARCH_SLICK_CARE_PROFILES_SUCCESS,
  //
  OPEN_WEBSITE_MODAL,
  CLOSE_WEBSITE_MODAL,
  //
  OPEN_ROOM_ADD_MODAL,
  CLOSE_ROOM_ADD_MODAL,
  //
  ADD_ROOM,
  ADD_ROOM_FAILURE,
  ADD_ROOM_SUCCESS,
  //
  FETCH_ROOMS,
  FETCH_ROOMS_FAILURE,
  FETCH_ROOMS_SUCCESS,
  //
  FETCH_ALL_LOCATION,
  FETCH_ALL_LOCATION_SUCCESS,
  FETCH_ALL_LOCATION_FAILURE,
  //
  OPEN_VIEW_ROOMS_MODAL,
  CLOSE_VIEW_ROOMS_MODAL,
  //
  FETCH_ALL_ROOMS,
  FETCH_ALL_ROOMS_SUCCESS,
  FETCH_ALL_ROOMS_FAILURE,
  //
  DELETE_CARE_ROOM,
  DELETE_CARE_ROOM_SUCCESS,
  DELETE_CARE_ROOM_FAILURE,
  //
  GET_CARE_ROOM_DATA,
  GET_CARE_ROOM_DATA_SUCCESS,
  GET_CARE_ROOM_DATA_FAILURE,
  //
  EDIT_CARE_ROOM,
  EDIT_CARE_ROOM_SUCCESS,
  EDIT_CARE_ROOM_FAILURE,
  //
  OPEN_INVITE_MODAL,
  CLOSE_INVITE_MODAL,
  //
  INVITE_STAFF,
  INVITE_STAFF_SUCCESS,
  INVITE_STAFF_FAILURE,
  //
  OPEN_COMPANY_MODAL,
  CLOSE_COMPANY_MODAL,
  //
  SEARCH_COMPANY,
  SEARCH_COMPANY_SUCCESS,
  SEARCH_COMPANY_FAILURE,
  //
  CHANGE_COMPANY,
  CHANGE_COMPANY_SUCCESS,
  CHANGE_COMPANY_FAILURE,
} from "./constants";

// List
export const fetchSlickCareProfiles = (payload) => ({
  type: FETCH_SLICK_CARE_PROFILES,
  payload,
});
export const fetchSlickCareProfilesSuccess = (payload) => ({
  type: FETCH_SLICK_CARE_PROFILES_SUCCESS,
  payload,
});
export const fetchSlickCareProfilesFailure = (payload) => ({
  type: FETCH_SLICK_CARE_PROFILES_FAILURE,
  payload,
});
// Search List
export const searchSlickCareProfiles = (payload) => ({
  type: SEARCH_SLICK_CARE_PROFILES,
  payload,
});
export const searchSlickCareProfilesSuccess = (payload) => ({
  type: SEARCH_SLICK_CARE_PROFILES_SUCCESS,
  payload,
});
export const searchSlickCareProfilesFailure = (payload) => ({
  type: SEARCH_SLICK_CARE_PROFILES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addSlickCareProfiles = (payload) => ({
  type: ADD_SLICK_CARE_PROFILES,
  payload,
});
export const addSlickCareProfilesSuccess = (payload) => ({
  type: ADD_SLICK_CARE_PROFILES_SUCCESS,
  payload,
});
export const addSlickCareProfilesFailure = (payload) => ({
  type: ADD_SLICK_CARE_PROFILES_FAILURE,
  payload,
});
// EDIT
export const editSlickCareProfiles = (payload) => ({
  type: EDIT_SLICK_CARE_PROFILES,
  payload,
});
export const editSlickCareProfilesSuccess = (payload) => ({
  type: EDIT_SLICK_CARE_PROFILES_SUCCESS,
  payload,
});
export const editSlickCareProfilesFailure = (payload) => ({
  type: EDIT_SLICK_CARE_PROFILES_FAILURE,
  payload,
});
// DELETE
export const deleteSlickCareProfiles = (payload) => ({
  type: DELETE_SLICK_CARE_PROFILES,
  payload,
});
export const deleteSlickCareProfilesSuccess = (payload) => ({
  type: DELETE_SLICK_CARE_PROFILES_SUCCESS,
  payload,
});
export const deleteSlickCareProfilesFailure = (payload) => ({
  type: DELETE_SLICK_CARE_PROFILES_FAILURE,
  payload,
});

export const openWebsiteModal = (payload) => ({
  type: OPEN_WEBSITE_MODAL,
  payload,
});

export const closeWebsiteModal = (payload) => ({
  type: CLOSE_WEBSITE_MODAL,
  payload,
});
//
export const openRoomAddModal = (payload) => ({
  type: OPEN_ROOM_ADD_MODAL,
  payload,
});
export const closeRoomAddModal = (payload) => ({
  type: CLOSE_ROOM_ADD_MODAL,
  payload,
});
// ADD
export const addRoom = (payload) => ({
  type: ADD_ROOM,
  payload,
});
export const addRoomSuccess = (payload) => ({
  type: ADD_ROOM_SUCCESS,
  payload,
});
export const addRoomFailure = (payload) => ({
  type: ADD_ROOM_FAILURE,
  payload,
});
// List
export const fetchRooms = (payload) => ({
  type: FETCH_ROOMS,
  payload,
});
export const fetchRoomsSuccess = (payload) => ({
  type: FETCH_ROOMS_SUCCESS,
  payload,
});
export const fetchRoomsFailure = (payload) => ({
  type: FETCH_ROOMS_FAILURE,
  payload,
});

export const fetchAllLocation = (payload) => ({
  type: FETCH_ALL_LOCATION,
  payload,
});
export const fetchAllLocationSuccess = (payload) => ({
  type: FETCH_ALL_LOCATION_SUCCESS,
  payload,
});
export const fetchAllLocationFailure = (payload) => ({
  type: FETCH_ALL_LOCATION_FAILURE,
  payload,
});
//
export const openViewRoomsModal = (payload) => ({
  type: OPEN_VIEW_ROOMS_MODAL,
  payload,
});
export const clostViewRoomsModal = (payload) => ({
  type: CLOSE_VIEW_ROOMS_MODAL,
  payload,
});
//
export const fetchAllRooms = (payload) => ({
  type: FETCH_ALL_ROOMS,
  payload,
});
export const fetchAllRoomsSuccess = (payload) => ({
  type: FETCH_ALL_ROOMS_SUCCESS,
  payload,
});
export const fetchAllRoomsFailure = (payload) => ({
  type: FETCH_ALL_ROOMS_FAILURE,
  payload,
});

export const deleteCareRoom = (payload) => ({
  type: DELETE_CARE_ROOM,
  payload,
});
export const deleteCareRoomSuccess = (payload) => ({
  type: DELETE_CARE_ROOM_SUCCESS,
  payload,
});
export const deleteCareRoomFailure = (payload) => ({
  type: DELETE_CARE_ROOM_FAILURE,
  payload,
});

export const getCareRoomData = (payload) => ({
  type: GET_CARE_ROOM_DATA,
  payload,
});
export const getCareRoomDataSuccess = (payload) => ({
  type: GET_CARE_ROOM_DATA_SUCCESS,
  payload,
});
export const getCareRoomDataFailure = (payload) => ({
  type: GET_CARE_ROOM_DATA_FAILURE,
  payload,
});
//
export const editCareRoom = (payload) => ({
  type: EDIT_CARE_ROOM,
  payload,
});
export const editCareRoomSuccess = (payload) => ({
  type: EDIT_CARE_ROOM_SUCCESS,
  payload,
});
export const editCareRoomFailure = (payload) => ({
  type: EDIT_CARE_ROOM_FAILURE,
  payload,
});
//
export const openInviteModal = (payload) => ({
  type: OPEN_INVITE_MODAL,
  payload,
});
export const closeInviteModal = (payload) => ({
  type: CLOSE_INVITE_MODAL,
  payload,
});
//
export const inviteStaff = (payload) => ({
  type: INVITE_STAFF,
  payload,
});
export const inviteStaffSuccess = (payload) => ({
  type: INVITE_STAFF_SUCCESS,
  payload,
});
export const inviteStaffFailure = (payload) => ({
  type: INVITE_STAFF_FAILURE,
  payload,
});

//
export const openCompanyModal = (payload) => ({
  type: OPEN_COMPANY_MODAL,
  payload,
});
export const closeCompanyModal = (payload) => ({
  type: CLOSE_COMPANY_MODAL,
  payload,
});

//
export const searchCompany = (payload) => ({
  type: SEARCH_COMPANY,
  payload,
});
export const searchCompanySuccess = (payload) => ({
  type: SEARCH_COMPANY_SUCCESS,
  payload,
});
export const searchCompanyFailure = (payload) => ({
  type: SEARCH_COMPANY_FAILURE,
  payload,
});

//
export const changeCompany = (payload, onSuccess) => ({
  type: CHANGE_COMPANY,
  payload,
  onSuccess,
});
export const changeCompanySuccess = (payload) => ({
  type: CHANGE_COMPANY_SUCCESS,
  payload,
});
export const changeCompanyFailure = (payload) => ({
  type: CHANGE_COMPANY_FAILURE,
  payload,
});
